import { CardApplicationStateService, EnumDto } from '@/api';

export default {
  getCardApplicationStates: async (): Promise<EnumDto[]> => {
    const response = await CardApplicationStateService.cardApplicationStateControllerGetAll();
    return response.data;
  },
};
